import { configReducer } from "../reducer/ConfigReducer";

export const reducer = configReducer;